import { useEffect, useState, useRef } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import TabExtraContent from '../common/TabExtraContent'
import UMCButton from '../common/UMCButton'
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Button } from 'antd'
import { DARK_GRAY } from "../../styles/styleUtils"
import getData from './GetData'
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import InputField from "./InputField"
import CustomDialog from './CustomDialog'
import parse from 'html-react-parser'

//========================================
// Dispatch Console parameters config page
//========================================
const ACDConfig = ({ onPrevious, onNext, activeProfile, trunkConfig, setTrunkConfig, configurationData, setConfigurationData }) => {
    const [errorsOnPage, setErrorsOnPage] = useState(0);

    const [workingSipTrunkConfig, setWorkingSipTrunkConfig] = useImmer({});

    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    const [footer, setFooter] = useState([]);

    const creationAllowed = useRef(false); // Used to check if ACD prefix value can be created
    const creationError = useRef(false); // Used to display the creation error cause 

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);
    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    let errorsOnRedraw = errorsOnPage;

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_TRUNK") + " : " + activeProfile.name));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        const fetchData = async () => {
            var url, response;

            try {
                url = SIP_URL + "/sipprofile/params/" + activeProfile.id;

                dispatch(setContentLoading(true));
                response = await getData(url, null, profileHandler);
                dispatch(setContentLoading(false));
            }
            catch (e) {
                console.error(e);
                dispatch(setContentLoading(false));
            }
        };

        if (trunkConfig?.Profile !== undefined) {
            setWorkingSipTrunkConfig(trunkConfig);
        } else {
            fetchData();
        }
    }, []);

    const profileHandler = (data) => {
        setConfigurationData(data[0]);
    }

    // DC ACD data handlers
    const updateACDPrefix = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_DispatchConsole_Prefix.ACD_Prefix.Local_Number = value; });
    }

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-DC_ACD-Config`, "_blank")
            }}
        />
    }

// Previous button handler. The previous page is the profile selection so we have to erase the trunk config
    const onPreviousPage = () => {
        setTrunkConfig({});
        onPrevious();
    }

    const creationHandler = (data) => {
        creationAllowed.current = data[0]?.creationPossible;
        creationError.current = data[0]?.errorCause;
    }

    // Check if ACD prefix can be created
    const checkACDPrefixCreation = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-acd-prefix-creation/" + nodeNumber + "/" + ccproductid + "/" + 
                workingSipTrunkConfig?.Profile?.UI_DispatchConsole_Prefix?.ACD_Prefix?.Local_Number;

            dispatch(setContentLoading(true));
            response = await getData(url, null, creationHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }

    // Validation handler for the page
    async function validateFields() {

        await checkACDPrefixCreation(); 

        if (creationAllowed.current === false) {
            setDlgType("Error");
            setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));   
            setMessage(parse(getTranslated(dict, "MSG_ACD_PREFIX_CANNOT_BE_CREATED") + (creationError.current ? "<br/>" + creationError.current : "")));
            setFooter(ok);
            showModal(true);
        }
    }

    const onContinue = async () => {

        // Update the parent state
        setTrunkConfig(workingSipTrunkConfig);

        await validateFields();

        if ((errorsOnRedraw === 0) && (creationAllowed.current === true)) {
            onNext();
        }
    }

    // Error handler (count errors on the page)
    const errorHandler = (value) => {

        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }

    // Create JSON config for SIPtrunk
    function createTrunkConfig() {
        let obj = { Profile: {} };
        Object.keys(configurationData.Profile).forEach(group => {
            obj.Profile[group] = {};
            Object.keys(configurationData.Profile[group]).forEach(key => {
                if (configurationData.Profile[group][key]?.defaultValue !== undefined) {
                    obj.Profile[group][key] = configurationData.Profile[group][key].defaultValue;
                }
                else {
                    var value = configurationData.Profile[group][key];

                    if (Array.isArray(value)) {
                        obj.Profile[group][key] = [];
                    } 
                    else if (typeof value === 'object' && value !== null) {
                        obj.Profile[group][key] = {}; 
                        Object.keys(value).forEach(subKey => {
                            obj.Profile[group][key][subKey] = value[subKey].defaultValue;
                        })
                    }
                }
            })
        });
        return obj;
    }

    if (configurationData?.Profile !== undefined && workingSipTrunkConfig?.Profile === undefined) {
        setWorkingSipTrunkConfig(createTrunkConfig());
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Buttons for modal footer
    const ok = [
        <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
            {getTranslated(dict, "LABEL_OK")}
        </Button>
    ];

    return (<>
        { 
            configurationData?.Profile?.UI_DispatchConsole_Prefix &&
                <div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_ACD_PREFIX_DATA")}
                    </Divider>

                    { // ACD prefix
                        configurationData?.Profile?.UI_DispatchConsole_Prefix?.ACD_Prefix?.Local_Number &&
                        <InputField label={getTranslated(dict, "PARAM_ACD_PREFIX")}
                            defaultValue={configurationData?.Profile?.UI_DispatchConsole_Prefix?.ACD_Prefix?.Local_Number?.defaultValue}
                            regexp={configurationData?.Profile?.UI_DispatchConsole_Prefix?.ACD_Prefix?.Local_Number?.pattern}
                            handleChange={updateACDPrefix}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_DispatchConsole_Prefix?.ACD_Prefix?.Local_Number} />
                    }
                </div>
        }

        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onPreviousPage}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_NEXT")}
                type="primary"
                onClick={onContinue}
                disabled={errorsOnPage !== 0} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType}
            onCancel={handleCancel}
        >
            {message}
        </CustomDialog>
    </>);
}

export default ACDConfig;